'use client'

import Link from 'next/link'

export default function ErrorLog({ error }: { error: any }) {
  return (
    <main className='grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8'>
      <div className='text-center'>
        <p className='text-2xl text-red-700 font-semibold'></p>
        <h1 className='mt-4 text-balance text-5xl font-bold tracking-tight text-zinc-900 sm:text-5xl'>Oops, something went wrong!</h1>
        <p className='mt-6 text-pretty text-zinc-500 sm:text-lg/8'>{error?.message || 'An unexpected error occurred.'}</p>
        <div className='mt-10 flex items-center justify-center gap-x-6'>
          [ <Link href='/'>Go Back Home</Link> ]
        </div>
      </div>
    </main>
  )
}
